import Vue from 'vue';

import { drag, drop } from './drag';

Vue.directive("drag", drag);
Vue.directive("drop", drop);